angular.module('myApp.services')
    .factory('audioVideoResponse', function() {
        var audioType     = 'audio';
        var videoType     = 'video';
        var textType      = 'text';
        var recordingNotActive = 'not-active';
        var recordingActive = 'active';
        var recordingPaused = 'paused';
        var recordingStoped = 'stopped';
        var type            = {};

        return {
            setType: function(qId, responseType) {
                qId = parseInt(qId);
                type[qId] = responseType;
            },
            getType: function(qId) {
                qId = parseInt(qId);
                if (type[qId]) {
                    return type[qId];
                }
                return textType;
            },
            typeAudio : audioType,
            typeVideo : videoType,
            typeText  : textType,
            recordNotActive : recordingNotActive,
            recordActive : recordingActive,
            recordPaused : recordingPaused,
            recordStopped : recordingStoped
        }
    });